import { orgSlice } from "./organizationUnitsSlice";
import * as actions from "./organizationUnitsActions";
import * as selectors from "./organizationUnitsSelectors";

export { actions };
export { selectors };
export default orgSlice.reducer;
